import Image from 'app/Components/Shared/Image/image';

import React, { useEffect, useState } from 'react';
import CheckBox from '../../../../Shared/CheckBox/Checkbox';
import ChannelsSwiper from '../channelsSwiper/channelsSwiper';

const PackagesWord = (props) => {
    console.log(props);
    const [openPackageDetails, setOpenPackageDetails] = useState([]);

    function openCloseDetails(selectedItem) {
        if (openPackageDetails.find(x => x == selectedItem)) {
            setOpenPackageDetails((products) => products.filter((item, index) => item !== selectedItem));
        }
        else {
            setOpenPackageDetails([...openPackageDetails, selectedItem]);
        }
    }

    function onSelectedPackages(selectedItem, isSelected) {
        props.onSelectedSubPackage(selectedItem, isSelected)
    }

    function getPrice(item){
      if(item.priceItemList?.length > 0){
        return (<div className='price-wrapper'>
           <div className="price">₪{item.priceItemList[0].price}</div>
        </div>)
      }else{
        return(<div className='price-wrapper'>
        <div className="price">₪{item.price}</div>
        </div>)
      }
    }

    function getPriceDetails(item){
      if(item.priceItemList?.length > 0){
        return (<div className='price-wrapper'>
          {item.priceItemList.map((item, index) => {
            return (
              <div className='price-row' key={index}>
                {index == 0 && <sapn className='text'>מחיר {item.priceText} </sapn>}
                {index != 0 && <span className='text'> {item.priceText} { '₪' + item.price } לחודש</span>}
                &nbsp;
              </div> )
          })}
        </div>)
      }else if(item.price != item.originalPrice){
        return (<div className='price-wrapper'>
          <div className='price-row'> מחיר לחודש במקום <span className='original-price'>₪<sapn className="price">{item.originalPrice}</sapn></span> לחודש</div>
        </div>)
      }
    }

    return (<div className='new-package-details-wrapper'>
        <div className='sub-packages-wrapper'>
            {props.package?.premiumPackages?.length > 0 &&
                <div className='sub-packages'>
                    <h4>חבילות ב{props.package.cmsData.title}</h4>
                    {props.package?.premiumPackages?.map((item, index) => {
                        let isSelected = props.selectedSubPackages?.length > 0
                            ? props.selectedSubPackages?.some(x => x.name == item.name)
                            : item.action?.toUpperCase() == "ADD";
                        let isExisting = item.action?.toUpperCase() == "EXISTING";
                        let title = item.cmsData?.selfCare?.title ? item.cmsData?.selfCare?.title : item.localizedName;
                        let isShowArrow = (item.cmsData?.selfCare?.description != undefined && item.cmsData?.selfCare?.description?.length != 0) ||
                            (item.cmsData?.channels != undefined && item.cmsData?.channels?.length != 0);
                        let isOpened = openPackageDetails.find(x => x == item.name);
                        return (<div key={index} className='sub-package'>
                            <div className="package-price-wrapper" >
                                {isExisting ?
                                    <div className='existing-package'>
                                        <Image className='checkmark-disable' src={require('../../images/icon-checkmark-disable.svg')} />
                                        <div className='package-name'>{title}</div>
                                    </div> :
                                    <div className='right-details'>
                                    <CheckBox
                                        id={item.name}
                                        checked={isSelected}
                                        label={title}
                                        onChange={() => onSelectedPackages(item, !isSelected)}
                                    />
                                    {getPriceDetails(item)}
                                    </div>
                                }
                                <div className='left-details'>
                                    {isExisting ?
                                        <div className='existing-package-text'>כבר יש לך</div> :
                                        getPrice(item)
                                    }
                                    <div className='arrow-wrapper' onClick={() => { openCloseDetails(item.name) }}>
                                        {isShowArrow && <i className={`arrow ${isOpened ? 'up' : 'down'}`} ></i>}
                                    </div>
                                </div>
                            </div>
                            {isOpened &&
                                <div className="package-details">
                                    <p>{item.cmsData?.selfCare?.description}</p>
                                    <ChannelsSwiper channels={item.cmsData.channels} />
                                </div>
                            }
                        </div>)
                    })}
                </div>
            }
        </div>
    </div>)

}
export default PackagesWord;
